var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(180 23.5 23.5)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "rotate(180 23.5 23.5)",
    stroke: "#00FFE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.999L12 9.99902L8 13.999",
    stroke: "#00332D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowCircular);
export default __webpack_public_path__ + "static/media/upArrowCircular.be32a6c1b3e4310cd8e7802b3eca016e.svg";
export { ForwardRef as ReactComponent };